import React from 'react';
import {Box, FormControlLabel, Grid, Switch} from '@mui/material';
import {STUDENT_FIELDS_MAPPING, EMPLOYEE_FIELDS_MAPPING} from '../const/ReportFieldsMapping';
import {GROUP_MEMBERS_TYPE} from '../../../../constants/GroupMembersType';

/* eslint-disable react/prop-types */
const FieldsTab = ({excludedFields, handleToggleField, setExcludedFields, memberType}) => {
    const fields =
        memberType === GROUP_MEMBERS_TYPE.employee
            ? EMPLOYEE_FIELDS_MAPPING
            : STUDENT_FIELDS_MAPPING;

    const editableFieldValues = fields.filter(f => !f.readonly).map(f => f.value);
    const allVisible = editableFieldValues.every(f => !excludedFields.includes(f));

    const handleToggleAll = () => {
        setExcludedFields(allVisible ? editableFieldValues : []);
    };

    return (
        <>
            <Box display="flex" justifyContent="end" mb={2}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={allVisible}
                            onChange={handleToggleAll}
                            color="primary"
                        />
                    }
                    label="All"
                    labelPlacement="end"
                />
            </Box>
            <Grid container spacing={1}>
                {[...fields]
                    .sort((a, b) => {
                        if (a.title === 'Legal Name') return -1;
                        if (b.title === 'Legal Name') return 1;
                        return a.title.localeCompare(b.title);
                    })
                    .map(({title, value, readonly}) => (
                        <Grid
                            item
                            xs={6}
                            sm={4}
                            key={value}
                            sx={{minWidth: 150}}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '100%',
                                }}
                            >
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={!excludedFields.includes(value)}
                                            onChange={() => handleToggleField(value)}
                                            color="primary"
                                            disabled={readonly}
                                        />
                                    }
                                    label={title}
                                    labelPlacement="end"
                                />
                            </Box>
                        </Grid>
                    ))}
            </Grid>
        </>
    );
};

export default FieldsTab;
